import React from "react";
import { Check, X } from "lucide-react";
import { SectionLabel, Reveal } from "../primitives";
import { Section, TCard } from "../shared";
import simonaImg from "@/assets/img/simona.png";

const fits = [
  "bereit bist, ehrlich hinzuschauen, auch wenn's unbequem wird",
  "Dich komplett aus dem alten Spielfeld lösen willst, auch wenn Du noch nicht weißt, wie das neue aussieht",
  "erfolgreich UND erfüllt sein willst – nicht eins gegen das andere eintauschen",
];

const noFits = [
  "auf der Suche nach einer magischen Wunderpille bist oder hoffst, dass ich Dir einfach sage, was Du wirklich, wirklich willst",
  "Dich nur berieseln lassen willst, ohne aktiv mitzumachen",
  "einen Ort suchst, an dem Du nur Deinen Frust rauslassen kannst, ohne bereit zu sein, aktiv an einer Verbesserung Deiner Situation zu arbeiten",
];

export default function FuerWenSection() {
  return (
    <Section testId="fuerwen-section" className="bg-espresso-2 py-24 text-gold md:py-36">
      <SectionLabel color="gold" testId="fuerwen-label">Eine Sache ist mir wichtig zu betonen</SectionLabel>
      <Reveal>
        <h2 className="mb-14 max-w-3xl font-heading text-3xl font-700 uppercase leading-[1.05] tracking-tight text-gold md:text-5xl" style={{ fontWeight: 700 }}>
          Unverschämt Erfolgreich ist definitiv nicht für jede das Richtige!
        </h2>
      </Reveal>
      <div className="grid gap-8 md:grid-cols-2">
        <Reveal delay={0.06}>
          <div className="h-full border border-cognac/40 p-8">
            <h3 className="mb-6 font-heading text-lg font-700 uppercase tracking-[0.1em] text-cognac-light" style={{ fontWeight: 700 }}>
              Es ist für Dich, wenn Du:
            </h3>
            <ul className="space-y-4">
              {fits.map((l) => (
                <li key={l} className="flex gap-3">
                  <Check className="mt-1 h-5 w-5 shrink-0 text-cognac-light" />
                  <p className="font-body text-base leading-[1.7] text-gold/85 md:text-lg">{l}</p>
                </li>
              ))}
            </ul>
          </div>
        </Reveal>
        <Reveal delay={0.12}>
          <div className="h-full border border-cognac/40 p-8">
            <h3 className="mb-6 font-heading text-lg font-700 uppercase tracking-[0.1em] text-gold/60" style={{ fontWeight: 700 }}>
              Das ist nicht der richtige Ort für Dich, wenn Du:
            </h3>
            <ul className="space-y-4">
              {noFits.map((l) => (
                <li key={l} className="flex gap-3">
                  <X className="mt-1 h-5 w-5 shrink-0 text-gold/50" />
                  <p className="font-body text-base leading-[1.7] text-gold/70 md:text-lg">{l}</p>
                </li>
              ))}
            </ul>
          </div>
        </Reveal>
      </div>
      <Reveal delay={0.14}>
        <div className="mt-14 max-w-2xl">
          <TCard
            dark
            img={simonaImg}
            name="Simona"
            lead="Ich habe ein Ziel vor Augen, bin motiviert und sehe endlich wieder einen Sinn in 'arbeiten' außer Geld verdienen!"
            ps={[
              "Vor dem Coaching war ich komplett planlos. Mein Job machte mir keinen Spaß, ich wusste nur, dass ich etwas anderes machen sollte. Die wenigen Ideen, die ich ab und zu hatte, wurden sofort von meinem eigenen Kopf auseinandergenommen und kritisiert, bis am Ende nichts übrig bleibt außer dem Gefühl „Ich werde nie herausfinden, was ich mit meinem (beruflichen) Leben anfangen soll und was ich eigentlich will. Vielleicht bin ich einfach nicht dafür gemacht zu arbeiten?!“",
              "Ich war am Anfang sehr skeptisch, ob das Coaching das Richtige für mich ist und bei mir überhaupt funktionieren kann. Der Glaubenssatz „Bei mir ist das anders, auf mich trifft das nicht zu“ saß sehr tief.",
              "1-2 Wochen nach dem Coaching hat es so richtig Klick gemacht! Jetzt weiß ich, wie ich weitermachen muss, ich bin auch nach Wochen noch total euphorisch, wenn ich darüber rede, wie es nun weitergeht, wie meine Arbeit aussehen soll und was ich damit erreichen möchte. Ich lasse mich auch nicht mehr so leicht von anderen beeinflussen und stehe zu mir.",
            ]}
            testId="testimonial-simona"
          />
        </div>
      </Reveal>
    </Section>
  );
}
